/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS13 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_12;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_13;
    },
    getDownloadName() {
      return ns.IOS13.nice_name;
    },
  });

  Object.assign(IOS13, {
    slug: `ios_13`,
    nice_name: `iOS 13 adoption`,
    description: `How quickly are consumers upgrading to iOS 13?`,
  });
  ns.IOS13 = IOS13;
});

}.call(window));